var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.url? 'nuxt-link' : 'div',{tag:"component",staticClass:"menu-media-item",class:[
        ("menu-text-item--" + _vm.styleType + "-style"),
        (_vm.dividerBefore? "menu-media-item--divider-before" : ''),
        (_vm.fullW? "menu-media-item--full-w" : '') ],attrs:{"to":_vm.localePath(_vm.url)}},[_c('common-media',{staticClass:"menu-media-item__image",attrs:{"media":_vm.info.media}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }